module.exports = __webpack_public_path__ + "img/succesful_txn_amount.fc65c13d.svg";